import { type PromotionViewType, type SellScreenActionTypes } from "../../Actions/SellScreen/SellScreenActions";
import { SELL_SCREEN_PROMOTION_TYPE_CHANGE } from "../../Actions/SellScreen/SellScreenConstants";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";

export interface PromotionsState {
    type: PromotionViewType | null;
}

function SellScreenPromotionsReducer(
    state: PromotionsState | undefined,
    action: ShopfrontActions<SellScreenActionTypes>
): PromotionsState {
    if(typeof state === "undefined") {
        return {
            type: null,
        };
    }

    switch(action.type) {
        case SELL_SCREEN_PROMOTION_TYPE_CHANGE:
            return {
                type: action.mode,
            };
        default:
            return state;
    }
}

export default SellScreenPromotionsReducer;
